module.exports = __webpack_public_path__ + "static/img/activity-bg.61227f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/activity-bg.jpg
// module id = XHsC
// module chunks = 0